import React from "react";
import AgentForm from "../Common/AgentForm";

export default function AddAgent() {
  return <AgentForm mode="add" />;
}
